module.exports = __webpack_public_path__ + "img/editor.aae1f946.svg";